<!-- version 2021/05/20 -->
<template>
    <a class="btn" :href="link">{{ title }}</a>
</template>

<script>
    export default {
        props: {
            link: String,
            title: String
        }
    }
</script>

<style lang="sass" scoped>
    @mixin arrow-left-position($color:rgba(0, 0, 0, 0.24), $rotate:45deg, $margin-top:0, $left:18px)
        position: relative
        display: inline-block
        &::before
            content: ''
            width: 10px
            height: 10px
            border: 0px
            border-top: solid 2px $color
            border-right: solid 2px $color
            -ms-transform: rotate($rotate)
            -webkit-transform: rotate($rotate)
            transform: rotate($rotate)
            position: absolute
            top: 50%
            left: $left
            margin-top: $margin-top

    %btn
        border-radius: 6px !important
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08) !important

    %btn-normal
        background-color: #FFF !important
        color: #28c3cd !important

    a
        padding-left: 24px
        @extend %btn
        @extend %btn-normal
        @include arrow-left-position(#28c3cd, 225deg, -6px, 12px)
        font-weight: 600

</style>
